import { render, staticRenderFns } from "./limitShop.vue?vue&type=template&id=01cff951&scoped=true&"
import script from "./limitShop.vue?vue&type=script&lang=js&"
export * from "./limitShop.vue?vue&type=script&lang=js&"
import style0 from "./limitShop.vue?vue&type=style&index=0&id=01cff951&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cff951",
  null
  
)

export default component.exports